import React, { useState } from 'react';
import { styled } from '@mui/material/styles';
import IconButton from '@mui/material/IconButton';
import Popover, { popoverClasses } from '@mui/material/Popover';
import Typography from '@mui/material/Typography';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import { ScoringInformationDto } from 'models/dtoTypes';

const StyledPoperover = styled(Popover)(({ theme }) => ({
  [`&.${popoverClasses.root}`]: {
    pointerEvents: 'none',
  },
  [`& .${popoverClasses.paper}`]: {
    padding: theme.spacing(1),
    background: 'transparent',
    opacity: 0.6,
  },
}));

interface OnMark {
  (id: string, markIsRead: boolean): Promise<void>;
}

interface Props {
  scoringInformation: ScoringInformationDto;
  onMark: OnMark;
}

export default function SeenButton(props: Props) {
  const { scoringInformation, onMark } = props;
  const { seen, id } = scoringInformation;
  const [read, setRead] = useState(seen);
  const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);

  React.useEffect(() => {
    setRead(!!scoringInformation.seen);
  }, [scoringInformation]);

  const handlePopoverOpen = (event: React.MouseEvent<HTMLElement, MouseEvent>) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const handleClick = async (read: boolean) => {
    await onMark(id || '', read);
  };

  const open = Boolean(anchorEl);
  return (
    <div>
      <Typography
        aria-owns={open ? 'mouse-over-popover' : undefined}
        aria-haspopup="true"
        onMouseEnter={handlePopoverOpen}
        onMouseLeave={handlePopoverClose}
      >
        <IconButton edge="end" aria-label="delete" onClick={() => handleClick(!read)}>
          <FiberManualRecordIcon
            style={{ fontSize: 15, visibility: read ? 'hidden' : 'visible' }}
            color="primary"
          />
        </IconButton>
      </Typography>
      <StyledPoperover
        id="mouse-over-popover"
        open={open}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        onClose={handlePopoverClose}
        disableRestoreFocus
      >
        <Typography>{read ? 'Mark as unread' : 'Mark as read'}</Typography>
      </StyledPoperover>
    </div>
  );
}
